import { render } from "./AlertFullMessage.vue?vue&type=template&id=7923f160&scoped=true"
import script from "./AlertFullMessage.vue?vue&type=script&lang=js"
export * from "./AlertFullMessage.vue?vue&type=script&lang=js"

import "./AlertFullMessage.vue?vue&type=style&index=0&id=7923f160&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7923f160"]])

export default __exports__